<script >
import { isPc } from '../assets/scripts/utils';
import QaForm from './QaForm.vue';
import useQuestionData from './useQuestionData';
import { useI18n } from '../assets/scripts/i18n';
import { provide } from 'vue-demi';
const __sfc_main = {};
__sfc_main.props = {
  act_sign: String,
  question_sign: String,
  lang: Number
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    plugins: {
      lang: langPlugin
    }
  } = require('@futuweb/fego-render');
  const props = __props;
  const {
    baseData,
    questions,
    questionStatus,
    userAnswer,
    authMode,
    getQuestion
  } = useQuestionData(props);
  const langText = langPlugin.getLangText(props.lang);
  const $t = useI18n(props.lang);
  provide('act_sign', props.act_sign);
  provide('question_sign', props.question_sign);
  provide('lang', props.lang);
  provide('$t', $t);
  return {
    isPc,
    baseData,
    questions,
    questionStatus,
    userAnswer,
    authMode,
    getQuestion,
    langText
  };
};
__sfc_main.components = Object.assign({
  QaForm
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <div
        v-if="question_sign"
        :class="[
            'question',
            langText,
            {
                pc: isPc()
            }
        ]"
    >
        <p class="question-title">{{ baseData.title }}</p>
        <p class="question-desc">{{ baseData.desc }}</p>
        <qa-form
            :questions="questions"
            :questionStatus="questionStatus"
            :userAnswer="userAnswer"
            :authMode="authMode"
            :isPc="isPc()"
            @refresh="getQuestion"
        ></qa-form>
    </div>
</template>
<style lang="less" scoped>
@import './index.less';
.question {
    height: auto !important;

    .question-title {
        font-size: var(--question-title-font-size);
        line-height: var(--question-title-line-height);
        color: #121212;
        font-weight: 600;
    }

    .question-desc {
        font-size: var(--question-desc-font-size);
        line-height: var(--question-desc-line-height);
        color: #626262;
        margin-top: 0.1rem;
    }
}
</style>
